import React from "react";
import { Platform, Text } from "react-native";
export default function Link({ children, style, href, }) {
    if (Platform.OS !== "web") {
        throw new Error("Link is unimplemented outside web");
    }
    return (<Text accessibilityRole="link" 
    // @ts-ignore RN types lack RNW href.
    href={href} style={React.useMemo(() => [
            {
                color: "inherit",
                textDecorationLine: "underline",
            },
            style,
        ], [style])}>
      <Text>{children}</Text>
    </Text>);
}
//# sourceMappingURL=Link.js.map